import { Component, ChangeDetectionStrategy, inject } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { SectionWrapperComponent } from '../section-wrapper/section-wrapper.component';
import { CtaButtonComponent } from '../cta-button/cta-button.component';
import { SiteConfigService } from '../../services/site-config.service';

@Component({
  selector: 'app-why-us',
  imports: [SectionWrapperComponent, MatIconModule, CtaButtonComponent],
  templateUrl: './why-us.component.html',
  styleUrl: './why-us.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WhyUsComponent {
  private readonly siteConfig = inject(SiteConfigService);

  readonly section = this.siteConfig.whyUs;
}
